import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { isDefined } from '@morpho-org/morpho-ts';
import { getSafeQuorum, hasAragonMetadata, type MetadataType } from '@/helpers/quorum';
import GuardianAddress from '../../GuardianAddress/GuardianAddress';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultPendingTimelock.components';
import VaultPendingTimelockHeader from './VaultPendingTimelockHeader';
interface VaultPendingTimelockChangeGuardianProps {
  chainId: ChainId;
  currentGuardian?: Address;
  currentGuardianMetadata?: readonly MetadataType[] | null;
  newGuardian: Address;
  newGuardianMetadata?: readonly MetadataType[] | null;
  functionName: string;
}
const VaultPendingTimelockChangeGuardian = t0 => {
  const $ = _c(36);
  const {
    currentGuardian,
    chainId,
    newGuardian,
    functionName,
    currentGuardianMetadata,
    newGuardianMetadata
  } = t0;
  let t1;
  if ($[0] !== currentGuardian || $[1] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName,
      hasPreviousValue: isDefined(currentGuardian)
    });
    $[0] = currentGuardian;
    $[1] = functionName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const config = t1;
  let t2;
  if ($[3] !== currentGuardianMetadata) {
    t2 = currentGuardianMetadata ?? [];
    $[3] = currentGuardianMetadata;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = hasAragonMetadata(t2);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isAragonDAOCurrent = t3;
  let t4;
  if ($[7] !== newGuardianMetadata) {
    t4 = newGuardianMetadata ?? [];
    $[7] = newGuardianMetadata;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = hasAragonMetadata(t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const isAragonDAONew = t5;
  let t6;
  if ($[11] !== currentGuardianMetadata) {
    t6 = currentGuardianMetadata ?? [];
    $[11] = currentGuardianMetadata;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = getSafeQuorum(t6);
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const safeQuorumCurrent = t7;
  let t8;
  if ($[15] !== newGuardianMetadata) {
    t8 = newGuardianMetadata ?? [];
    $[15] = newGuardianMetadata;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = getSafeQuorum(t8);
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const safeQuorumNew = t9;
  let t10;
  if ($[19] !== config) {
    t10 = config && <VaultPendingTimelockHeader title={config.label} criticality={config.criticality} />;
    $[19] = config;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== chainId || $[22] !== currentGuardian || $[23] !== isAragonDAOCurrent || $[24] !== safeQuorumCurrent) {
    t11 = currentGuardian && <StyledVaultPendingTimelock.Row><span className="text-2xs text-foreground">Previous guardian</span><GuardianAddress chainId={chainId} address={currentGuardian} isAragonDAO={isAragonDAOCurrent} safeQuorum={safeQuorumCurrent} /></StyledVaultPendingTimelock.Row>;
    $[21] = chainId;
    $[22] = currentGuardian;
    $[23] = isAragonDAOCurrent;
    $[24] = safeQuorumCurrent;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-2xs text-foreground">New guardian</span>;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== chainId || $[28] !== isAragonDAONew || $[29] !== newGuardian || $[30] !== safeQuorumNew) {
    t13 = <StyledVaultPendingTimelock.Row>{t12}<GuardianAddress chainId={chainId} address={newGuardian} isAragonDAO={isAragonDAONew} safeQuorum={safeQuorumNew} /></StyledVaultPendingTimelock.Row>;
    $[27] = chainId;
    $[28] = isAragonDAONew;
    $[29] = newGuardian;
    $[30] = safeQuorumNew;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t13) {
    t14 = <div className="flex w-[100%] flex-col">{t10}{t11}{t13}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export default VaultPendingTimelockChangeGuardian;